import React from 'react';
import UserContext from 'context/UserContext';

const useAuth = (auth: string) => {
    const {userInfo} = React.useContext(UserContext);
    return !!(userInfo?.auth && userInfo?.auth[auth]);
};
export default useAuth;